<div class="phone-input-wrapper">
  <div
    class="global-icon phone-icon"
    aria-label="phone"
  ></div>
  <input
    [readOnly]="readOnly"
    [disabled]="disabled"
    [ngClass]="disabled ? 'disabled' : ''"
    [(ngModel)]="value"
    (blur)="onTouch()"
    (keypress)="onlyNumberKey($event)"
    class="phone-input"
    type="tel"
    maxlength="35"
    placeholder="+XXX XXX XX XX XX"
  />
</div>
